import { Navigate } from "react-router-dom";
import { useAppSelector } from "./Redux/hooks";

const Home = () => {
  const isUserAuthenticated = useAppSelector(
    (state) => state.user.isUserAuthenticated,
  );
  const role = useAppSelector((state) => state.user.role);

  if (!isUserAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  if (role === "participant") {
    const studySlug = localStorage.getItem("study-slug");
    return (
      <Navigate
        to={studySlug ? `/study/${studySlug}` : "/auth/participant/login"}
        replace
      />
    );
  }

  return <Navigate to="/app/studies" replace />;
};

export default Home;
